import {CrudEditHeader} from 'app/Components'
import {CrudAction, getRow, Type} from 'lib/crud'
import {State} from 'lib/store'
import {name as studentsName, Student} from 'lib/students'
import * as React from 'react'
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux'
import {withRouter} from 'react-router'
import {RouteComponentProps} from 'react-router-dom'
import {IndividualClass, name} from 'lib/individualClass'
import {Tabs} from '../Tabs'
import {Form} from './Form'

type StateToProps = {
    readonly student: Student
    readonly individualClass: IndividualClass
}

type DispatchToProps = {
    readonly load: (actionName: string, id: string) => void,
    readonly handleSubmit: (individualClass: IndividualClass) => void,
}

type Params = {
    parentId: string
}

class EditComponent extends React.Component<StateToProps & DispatchToProps & RouteComponentProps<Params>> {
    public componentDidMount(): void {
        if (this.props.match.params.parentId) {
            this.props.load(studentsName, this.props.match.params.parentId)
        }
    }

    public render = () => (<>
        <CrudEditHeader actionName={name}/>
        <Tabs id={this.props.match.params.parentId} />
        {this.props.student.id != undefined
            ? <Form initialValues={this.props.individualClass} handleSubmit={this.props.handleSubmit}/>
            : null}
    </>)
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    student: getRow(state => state.students)(state),
    individualClass: getRow(state => state.individualClass)(state),
})

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, {}> = dispatch => ({
    load: (actionName: string, id: string) => {
        dispatch(CrudAction.execute(actionName, Type.GET, {id}))
    },
    handleSubmit: (individualClass: IndividualClass) => {
        const individualClassId = individualClass.id
        delete individualClass.id
        dispatch(CrudAction.execute(name, Type.UPDATE, {
            id: individualClassId,
            data: individualClass
        }))
    }
})

export const Edit = withRouter(connect(mapStateToProps, mapDispatchToProps)(EditComponent))